// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Kr","icon":"e_Lr"};